import React, {createRef, useState} from "react";
import {StyledArea} from "./index.styles";
import {Form, Grid, message} from "antd";
import {StyledSection8Container} from "../../components/pages/Main/Section8/Section8.styles";
import {MapContainer, Polygon, TileLayer} from "react-leaflet";
import {Section10, SectionArea2} from "../../components";
import {MyButton} from "../../components/common/MyButton/MyButton";
import {axiosConfig} from "../../config/axios.config";

import brandListJson from '../../assets/data/arrayOfBrands.json'
import servicesListJson from "../../assets/data/services.json";
import {MyModal} from "../../components/common/MyModal/MyModal";
const {useBreakpoint} = Grid
export const Area = () => {
  const [form] = Form.useForm();

  const servicesList = servicesListJson
  const brandList = brandListJson

  const screens = useBreakpoint()
  const center = [33.0593, -117.1307]

  const recaptchaRef = createRef();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false)

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleReCaptchaChange = (value) => {
    console.log("handleReCaptchaChange value",value)
  }

  const onFinishForm = (values) => {
    setLoading(true)
    const recaptchaVal = recaptchaRef.current.getValue();


    form.validateFields().then(() => {

          if (recaptchaVal) {
            return axiosConfig.post("/api/axis/client-lead", {...values}).then((res) => {
              form.resetFields()
              setLoading(false)
              setIsModalOpen(!isModalOpen)
              return message.success({content: "Submitted"})
            }).catch((res) => {
              setLoading(false)
            })
          } else {
            setLoading(false)
            return message.error("Recaptcha error")
          }
        }
    )
  }

  const polygon = [
    [32.5705412, -116.7723083],
    [32.5381306, -117.2090149],
    [32.7497451, -117.3298645],
    [33.090391, -117.4150085],
    [33.1582477, -117.4390411],
    [33.332823, -117.3538971],
    [33.6734971, -117.3930359],
    [33.7066339, -116.9982147],
    [33.4537869, -116.9446564],
    [32.8242111, -116.7489624],
    [32.5745917, -116.7736816],
  ]

  return (
    <StyledArea>
      <StyledSection8Container>
        <MapContainer center={center} zoom={9} scrollWheelZoom={false} style={{width: "100%"}}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Polygon pathOptions={{color: "rgba(0, 51, 153, 1)", weight: 1}} positions={polygon}/>
        </MapContainer>
        <MyButton style={{position: "absolute", bottom: 40, right: !screens.lg ? 20 : 318, zIndex: 6}} type="primary" onClick={() => setIsModalOpen(true)}>Schedule Appointment</MyButton>
      </StyledSection8Container>
      <SectionArea2 setIsModalOpen={setIsModalOpen} />
      <Section10 />


      <MyModal screens={screens} form={form} loading={loading} isModalOpen={isModalOpen} handleOk={handleOk} handleCancel={handleCancel}
               onFinishForm={onFinishForm} servicesList={servicesList} brandList={brandList} recaptchaRef={recaptchaRef}
               handleReCaptchaChange={handleReCaptchaChange}/>
    </StyledArea>
  )
}